<template>
  <div id="app">
    <router-view />
    <EnginePreLoad v-if="isStartLoadEngine" />
  </div>
</template>

<script>
import EnginePreLoad from '@/components/EnginePreLoad'
import { isMobileDevice, getToken } from '@/utils/generalMethods'
import { getUserInfoByCenter } from '@/service/interface'
export default {
  data() {
    return {
      isStartLoadEngine: false
    }
  },
  components: {
    EnginePreLoad
  },
  mounted() {
    document.title = window.tabTitle
    this.$theme.clear()
    const themeType = this.getThemeType()
    this.$theme.set(themeType.name)

    if (!window.baiduDisabled) {
      let script = document.createElement('script')
      script.setAttribute('microprefetch', '')
      script.async = true
      script.src = './js/bmap/bmap.js'
      document.body.append(script)
    }

    if (isMobileDevice()) {
      this.loadScripts('mobileSDK')
    } else {
      document.body.style.minWidth = '1500px'
      this.loadScripts('webSDK')
    }
    if (window.isStarRiver) {
      this.addTokenCheckTimer()
    }

    this.$nextTick(() => {
      setTimeout(() => {
        this.isStartLoadEngine = true
      }, 100)
    })
  },
  beforeDestroy() {
    this.destroyTimer()
  },
  methods: {
    addTokenCheckTimer() {
      if (!this.timer) {
        this.timer = setInterval(this.checkToken, window.offlineCheckInterval)
      }
    },
    checkToken() {
      let token = ''
      let oldToken = sessionStorage.getItem('oldToken')
      if (oldToken) {
        token = oldToken
      } else {
        token = getToken()
      }
      if (!token) {
        this.destroyTimer()
        return
      }

      let headers = { Authorization: token }
      getUserInfoByCenter(headers).then(res => {
        if (res.status === 200) {
          let data = res.data
          if (!data.isSuccess) {
            this.destroyTimer()
          }
        } else {
          this.destroyTimer()
        }
      })
    },
    destroyTimer() {
      this.timer && clearInterval(this.timer)
      this.timer = null
    },
    async loadScripts(pathPrefix) {
      let scripts = ['RealBIMWeb.preload.js', 'RealBIMWeb.js']
      let basePath = ''
      if (window.isLogoVisible) {
        basePath = './js/bimEngine3D/default'
        scripts.push('BlackHole3D.js')
      } else {
        basePath = './js/bimEngine3D/nologo'
        scripts.push('BimEngine3D.js')
      }

      // scripts.forEach(scriptName => {
      //   let script = document.createElement('script')
      //   script.setAttribute('microprefetch', '')
      //   script.src = `${basePath}/${pathPrefix}/${scriptName}`
      //   document.body.append(script)
      // })

      for (const scriptName of scripts) {
        try {
          await this.loadScript(`${basePath}/${pathPrefix}/${scriptName}`)
        } catch (error) {
          console.error(`${scriptName} 加载失败:`, error)
          // throw error; // 如果后续脚本依赖当前脚本，可以选择终止
        }
      }
    },
    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = src
        script.setAttribute('microprefetch', '')
        script.async = false // 保持顺序执行
        script.onload = () => resolve('加载完成')
        script.onerror = error => reject(new Error(`加载脚本失败: ${src}`))
        document.body.appendChild(script)
      })
    },

    getThemeType() {
      return this.$theme.get()
    }
  }
}
</script>

<style lang="less">
#app {
  // font-family: system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue',
  //   'Noto Sans', 'Liberation Sans', Arial, sans-serif, 'Apple Color Emoji',
  //   'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  text-align: center;
  color: var(--default-color);
  background: var(--home-bg-color);
  user-select: none;
  overflow: hidden;
}
body {
  // font-family: 'Source Han Sans CN', Rototo, Emoji, Helvetica, Arial, sans-serif;
}
</style>
